module.exports = __webpack_public_path__ + "static/img/live-hr-advice-icon.cf6de00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/live-hr-advice-icon.png
// module id = 4I/s
// module chunks = 0